import { AreaShape } from 'api';

export const isAreaShape = (value: unknown): value is AreaShape =>
  typeof value === 'string' && Object.keys(AreaShape).includes(value);
